export default "__VITE_ASSET__BKXDG4yb__"